export default __webpack_public_path__ + "static/footerLockupLogo-2c6867e22e1ef1aedb63ec2b23b5b1a8.png";